<div class="p-8">
    <div class="text-4xl font-semibold mb-4">Profile</div>
    <div class="bg-white border border-gray-200 rounded-xl p-6">
        <div class="flex justify-center items-center">
            <img src="https://i.pravatar.cc/100?img=5" class="w-26 h-26 rounded-full" />
        </div>
        <div class="max-w-6xl mx-auto mt-5">
            <div class="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div class="flex flex-col">
                    <div class="space-y-3">
                        <div class="text-lg font-medium">Name</div>
                        <input type="text" [(ngModel)]="profileData.name"
                            class="w-full p-3 bg-[#F5F6FA] border border-gray-200 rounded-lg">
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="space-y-3">
                        <div class="text-lg font-medium">Email</div>
                        <input type="email" [(ngModel)]="profileData.email"
                            class="w-full p-3 bg-[#F5F6FA] border border-gray-200 rounded-lg">
                    </div>
                </div>
                <div class="flex flex-col">
                    <div class="space-y-3">
                        <div class="text-lg font-medium">Username</div>
                        <input type="text" [(ngModel)]="profileData.username"
                            class="w-full p-3 bg-[#F5F6FA] border border-gray-200 rounded-lg">
                    </div>
                </div>
            </div>
        </div>
        <div class="flex justify-center items-center mt-5">
            <button type="button" (click)="updateProfile()" [disabled]="isSubmitting"
                class="bg-blue-600 hover:bg-blue-700 text-white px-4 py-2 rounded-lg disabled:opacity-50 disabled:cursor-not-allowed">
                {{ isSubmitting ? 'Updating...' : 'Update Profile' }}
            </button>
            <button type="button" (click)="openChangePasswordModal()" class="ml-4 bg-red-600 hover:bg-red-700 text-white px-4 py-2 rounded-lg">Change Password</button>
        </div>
    </div>
</div>

<div
    *ngIf="isModalOpen"
    class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50 p-4"
>
    <div
        class="bg-white rounded-lg shadow-xl max-w-md w-full p-6 animate-fadeIn"
    >
        <div class="flex justify-between items-center mb-6">
            <h2 class="text-2xl font-bold text-gray-900">
                Change Password
            </h2>
            <button
                (click)="closeChangePasswordModal()"
                class="text-gray-400 hover:text-gray-600 text-2xl"
            >
                &times;
            </button>
        </div>

        <form #locationFormElement="ngForm">
            <!-- Current Password -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Current Password <span class="text-red-500">*</span>
                </label>
                <input
                    type="password"
                    [(ngModel)]="current_password"
                    name="current_password"
                    required
                    minlength="6"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="************"
                />
            </div>

            <!-- New Password -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    New Password <span class="text-red-500">*</span>
                </label>
                <input
                    type="password"
                    [(ngModel)]="password"
                    name="password"
                    required
                    minlength="6"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="************"
                />
            </div>

            <!-- Confirm Password -->
            <div class="mb-4">
                <label class="block text-sm font-medium text-gray-700 mb-2">
                    Confirm Password <span class="text-red-500">*</span>
                </label>
                <input
                    type="password"
                    [(ngModel)]="password_confirmation"
                    name="password_confirmation"
                    required
                    minlength="6"
                    class="w-full px-4 py-2 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-blue-500"
                    placeholder="************"
                />
            </div>

            <!-- Buttons -->
            <div class="flex gap-3">
                <button
                    type="button"
                    (click)="closeChangePasswordModal()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 border border-gray-300 text-gray-700 rounded-lg hover:bg-gray-50 transition disabled:opacity-50"
                >
                    Cancel
                </button>
                <button
                    type="button"
                    (click)="updatePassword()"
                    [disabled]="isSubmitting"
                    class="flex-1 px-4 py-2 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition disabled:opacity-50 disabled:cursor-not-allowed"
                >
                    <span *ngIf="!isSubmitting">
                        Update Password
                    </span>
                    <span *ngIf="isSubmitting"> Processing... </span>
                </button>
            </div>
        </form>
    </div>
</div>
